import { render } from "./gdpr-cookies.vue?vue&type=template&id=00a887ca"
import script from "./gdpr-cookies.vue?vue&type=script&lang=js"
export * from "./gdpr-cookies.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__